import {
    ADD_SURVEY_MIDDLE,
    EDIT_SURVEY_MIDDLE,
    LIST_SURVEY_MIDDLE,
    VIEW_SURVEY_MIDDLE,
    DELETE_SURVEY_MIDDLE,

    SURVEY_MIDDLE_SUCCESS,
    SURVEY_MIDDLE_ERROR,
  
  } from "./actionTypes"
  const initialState = {
    successMsg: null,
    error: null,
    editLoading:false
  }
  
  const configSurveyMiddle = (state = initialState, action) => {
    switch (action.type) {
  
      // add SURVEY_MIDDLE
      case ADD_SURVEY_MIDDLE:
        state = {
          ...state,
          editLoading: true,
          
          successMsg: null,
          error: null,
        }
        break
      case SURVEY_MIDDLE_SUCCESS:
        state = {
          ...state,
          loading: false,
          successMsg: action.payload,
          editLoading:false
        }
        break
      case SURVEY_MIDDLE_ERROR:
        state = { ...state, error: action.payload, loading: false,editLoading:false }
        break
  
      // edit SURVEY_MIDDLE
      case EDIT_SURVEY_MIDDLE:
        state = {
          ...state,
          editLoading: true,
          successMsg: null,
          error: null,
        }
        break
  
      // list SURVEY_MIDDLE
      case LIST_SURVEY_MIDDLE:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break
  
      // view SURVEY_MIDDLE
      case VIEW_SURVEY_MIDDLE:
        state = {
          ...state,
          successMsg: null,
          error: null,
        }
        break
  
      // delete SURVEY_MIDDLE
      case DELETE_SURVEY_MIDDLE:
        state = {
          ...state,
          loading: true,
          successMsg: null,
          error: null,
        }
        break

      default:
        state = { ...state }
        break
    }
    return state
  }
  
  export default configSurveyMiddle
  